import React from 'react';
import { faq } from '../data/mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  return (
    <section id="faq" className="section-padding bg-[#f8fafc]">
      <div className="container">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Left - Header */}
          <div className="lg:sticky lg:top-32">
            <p className="text-sm uppercase tracking-widest text-[#b8860b] font-medium mb-4">
              FAQ
            </p>
            <h2 className="heading-1 text-[#0f172a] mb-6">
              Frequently Asked Questions
            </h2>
            <p className="body-regular text-[#475569] mb-8">
              Find answers to common questions about my practice, services, and policies.
            </p>
            <p className="text-sm text-[#64748b]">
              Have a question not listed here?{' '}
              <a href="#contact" className="text-[#0f172a] font-medium hover:text-[#b8860b] transition-colors">
                Contact me directly
              </a>
            </p>
          </div>

          {/* Right - Accordion */}
          <div>
            <Accordion type="single" collapsible className="w-full">
              {faq.map((item, index) => (
                <AccordionItem
                  key={index}
                  value={`faq-${index}`}
                  className="border-b border-[#e2e8f0] bg-white mb-2"
                >
                  <AccordionTrigger className="px-6 py-5 hover:no-underline text-left">
                    <span className="text-[#0f172a] font-medium pr-4">
                      {item.question}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="px-6 pb-5">
                    <p className="text-[#475569] text-sm leading-relaxed">
                      {item.answer}
                    </p>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
